import React from "react";
import "./PageIndicator.css";

const PageIndicator = ({ 
  totalSlides, 
  activeIndex, 
  onChange, 
  color = "#40BBD2",
  mt = null, // Add margin-top prop
  style = {} // Optional: for additional styles
}) => {
  const handleDotClick = (index) => {
    if (onChange && index !== activeIndex) {
      onChange(index);
    }
  };

  // Combine custom styles
  const containerStyle = mt ? { marginTop: `${mt}px`, ...style } : style;

  return (
    <div className="page-indicators" style={containerStyle}>
      <div className="indicators-container">
        {Array.from({ length: totalSlides }).map((_, index) => (
          <button
            key={index}
            className={`indicator-dot ${index === activeIndex ? "active" : ""}`}
            onClick={() => handleDotClick(index)}
            aria-label={`Go to slide ${index + 1}`}
            style={{
              backgroundColor: index === activeIndex ? color : 'rgba(255, 255, 255, 0.3)'
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default PageIndicator;